"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toast = exports.messagesLens = exports.initialState = void 0;
const monocle = require("monocle-ts");
const Actions = require("../actionTypes/toast");
//#endregion
//#region INITIAL STATE
exports.initialState = {
    messages: []
};
//#endregion
//#region LENS
exports.messagesLens = monocle.Lens.fromProp('messages');
const methods = {};
methods[Actions.ADD_NEW_TOAST] = (state, action) => exports.messagesLens.modify((messages) => [action.payload, ...messages])(state);
methods[Actions.REMOVE_TOAST] = (state, action) => exports.messagesLens.modify((messages) => messages.filter(({ uuid }) => uuid !== action.payload))(state);
methods[Actions.CLEAR] = (state) => exports.messagesLens.set([])(state);
//#endregion REDUCER
const toast = (state = exports.initialState, action) => {
    const fn = methods[action.type];
    if (fn) {
        return fn(state, action);
    }
    return state;
};
exports.toast = toast;
//#endregion
//# sourceMappingURL=toast.js.map